import React from "react";

// Ícone de folha (símbolo de sustentabilidade / ESG) usado ao lado do valor de
// emissão de CO₂ na cotação. SVG inline porque o tim-icons do projeto não tem
// folha (só icon-planet/icon-world). `fill: currentColor` faz a folha herdar a
// cor verde do texto do selo de carbono.
// Obs.: fica em components/LeafIcon (e não components/icons) porque o
// .gitignore_global ignora "Icon?"/icons.
const LeafIcon = ({ size = 14, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    style={{ verticalAlign: "-2px", marginRight: 4, flexShrink: 0, ...style }}
  >
    <path d="M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z" />
  </svg>
);

export default LeafIcon;
